<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Kişisel Bilgiler</b-card-title>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Doğum Tarihi">
                <b-form-datepicker
                  v-model="formData.birthday"
                  v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                  locale="tr"
                  start-weekday="1"
                  class="mb-1"
                  :max="today"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Kimlik Numarası">
                <cleave
                  id="phone_business"
                  v-model="formData.idno"
                  class="form-control"
                  :raw="false"
                  :options="options.block"
                  placeholder="Kimlik Numarası"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Medeni Hal">
                <v-select
                  v-model="formData.id_maritals"
                  :options="maritals"
                  label="title"
                  :reduce="maritals => maritals.id"
                  placeholder="Medeni Hal Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Cinsiyet">
                <v-select
                  v-model="formData.id_genders"
                  :options="genders"
                  label="title"
                  :reduce="genders => genders.id"
                  placeholder="Cinsiyet Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Engel Derecesi">
                <v-select
                  v-model="formData.id_disabilities"
                  :options="disabilities"
                  label="title"
                  :reduce="disabilities => disabilities.id"
                  placeholder="Engel Derecesi Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Uyruğu">
                <b-form-input
                  v-model="formData.nationality"
                  placeholder="Uyruğu"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Çocuk Sayısı">
                <cleave
                  v-model="formData.childrens"
                  class="form-control"
                  :raw="false"
                  :options="options.number"
                  placeholder="Çocuk Sayısı"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Kan Grubu">
                <v-select
                  v-model="formData.id_blood_group"
                  :options="bloodGroups"
                  label="title"
                  :reduce="bloodGroups => bloodGroups.id"
                  placeholder="Kan Grubu Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Eğitim Seviyesi">
                <v-select
                  v-model="formData.id_education_levels"
                  :options="educationLevels"
                  label="title"
                  :reduce="educationLevels => educationLevels.id"
                  placeholder="Eğitim Seviyesi Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Eğitim Durumu">
                <v-select
                  v-model="formData.id_educational_statuses"
                  :options="educationalStatuses"
                  label="title"
                  :reduce="educationalStatuses => educationalStatuses.id"
                  placeholder="Eğitim Durumu Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="submitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BCard, BCardTitle, BFormGroup, BFormInput, BFormDatepicker, BButton,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'

export default {
  name: 'Personal',
  components: {
    BFormDatepicker,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormInput,
    BFormGroup,
    Cleave,
    BButton,
    vSelect,
  },
  data() {
    return {
      today: this.moment().format('YYYY-MM-DD'),
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        block: {
          blocks: [11],
          uppercase: true,
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundreds',
        },
      },
      formData: {
        id: null,
        started: null,
        id_departments: null,
        id_employee_tasks: null,
        id_manager_employees: null,
        id_employees: null,
      },
    }
  },
  computed: {
    personals() {
      return this.$store.getters['employeePersonal/getEmployeePersonals']
    },
    bloodGroups() {
      return this.$store.getters['bloodGroup/getBloodGroups']
    },
    maritals() {
      return this.$store.getters['maritals/getMaritals']
    },
    genders() {
      return this.$store.getters['genders/getGenders']
    },
    educationLevels() {
      return this.$store.getters['educationLevels/getEducationLevels']
    },
    educationalStatuses() {
      return this.$store.getters['educationalStatuses/getEducationalStatuses']
    },
    disabilities() {
      return this.$store.getters['disabilities/getDisabilities']
    },
    saveStatus() {
      return this.$store.getters['employeePersonal/getEmployeePersonalSaveStatus']
    },
  },
  watch: {
    personals(val) {
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getEmployeePersonal()
    this.getBloodGroups()
    this.getMaritals()
    this.getGenders()
    this.getEducationLevels()
    this.getEducationalStatuses()
    this.getDisabilities()
  },
  methods: {
    getEmployeePersonal() {
      this.$store.dispatch('employeePersonal/employeePersonalsList', {
        where: {
          'employee_personal.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getBloodGroups() {
      this.$store.dispatch('bloodGroup/bloodGroupsList')
    },
    getMaritals() {
      this.$store.dispatch('maritals/maritalsList')
    },
    getGenders() {
      this.$store.dispatch('genders/gendersList')
    },
    getEducationLevels() {
      this.$store.dispatch('educationLevels/educationLevelsList')
    },
    getEducationalStatuses() {
      this.$store.dispatch('educationalStatuses/educationalStatusesList')
    },
    getDisabilities() {
      this.$store.dispatch('disabilities/disabilitiesList')
    },
    setFormData(data) {
      this.formData = data
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('employeePersonal/employeePersonalSave', this.formData)
      this.formData = null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
